import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, Input } from '@angular/core';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'sg-detail-item-card',
  templateUrl: './detail-item-card.component.html',
  styleUrls: ['./detail-item-card.component.scss'],
  standalone: false,
})
export class SgDetailItemCardComponent {
  @Input() icon: string;
  @Input() category: string;
  @Input() subtitle: string;
  @Input() tag: { text: string; status?: 'success' | 'attention' };
  @Input() header: {
    title: string;
    subtitle?: string;
  };
  @Input() busy: Observable<boolean> = of(false);
  @Input() set showMiniHeader(value: boolean) {
    this._showMiniHeader = coerceBooleanProperty(value);
  }
  _showMiniHeader = true;

  @Input() set showActionOnBusy(value: BooleanInput) {
    this._showActionOnBusy = coerceBooleanProperty(value);
  }
  _showActionOnBusy = false;
}
